const customEases = {
	icon: "cubic-bezier(0.215, 0.61, 0.355, 1)",
	cubic: {
		in: "cubic-bezier(0.4, 0, 1, 1)",
		out: "cubic-bezier(0, 0, 0.2, 1)",
	},
}

export default customEases
